//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {

    name: 'ProductPagination',

    props: {
        meta: {
            type: Object,
            default: () => {}
        },
        links: {
            type: Object,
            default: () => {}
        },
        urlRewrite: {
            type: Boolean,
            default: false
        },
        isSearch: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
        }
    },

    head() {
        return {
            link: this.headLinks()
        }
    },

    methods: {

        checkUrl(url) {

            if(this.urlRewrite === false) {
                return url
            }

            if(!url) {
                return ''
            }

            return url.replace('?', '/').replace('=', '/')
        },

        getFirstLink() {

            if(this.isSearch) {
                return this.links.first
            }

            return this.meta.path

        },

        getPrevLink() {

            let prevLink

            if(this.links.first === this.links.prev) {
                prevLink = this.getFirstLink()
            } else {
                prevLink = this.links.prev
            }

            return prevLink

        },

        headLinks() {

            let links = [];

            if(this.links.prev) {

                let prevLink = this.getPrevLink()

                var prev = { rel: 'prev', href: this.checkUrl(prevLink) }
                links.push(prev)
            }

            if(this.links.next) {
                var next = { rel: 'next', href: this.checkUrl(this.links.next) }
                links.push(next)
            }

            return links

        },

    },

    computed: {

        linkCollection() {
            return this.meta.links.slice(1,-1)
        },

    },

}

